import { render } from "./sevice.vue?vue&type=template&id=009ce6ea&scoped=true"
import script from "./sevice.vue?vue&type=script&lang=js"
export * from "./sevice.vue?vue&type=script&lang=js"

import "./sevice.vue?vue&type=style&index=0&id=009ce6ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009ce6ea"]])

export default __exports__